import types from "./types";

const INITIAL_STATE = {
  isFetchingToken: false,
  isFetchingProviders: false
};

const powerBIReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case types.GET_POWERBI_TOKEN_REQUEST:
      return {
        ...state,
        isFetchingToken: true,
      };

    case types.GET_POWERBI_TOKEN_SUCCESS:
      return {
        ...state,
        isFetchingToken: false,
      };

    case types.GET_POWERBI_TOKEN_FAILURE:
      return {
        ...state,
        isFetchingToken: false,
      };

    case types.GET_POWERBI_PROVIDER_REQUEST:
      return {
        ...state,
        isFetchingProviders: true,
      };

    case types.GET_POWERBI_PROVIDER_SUCCESS:
      return {
        ...state,
        isFetchingProviders: false,
      };

    case types.GET_POWERBI_PROVIDER_FAILURE:
      return {
        ...state,
        isFetchingProviders: false,
      };

    default:
      return state;
  }
};

export default powerBIReducer;
